export const winMarkets = [
  {
    name: 'roundNumberAfterShuffle',
    iconClass: 'player-chips-info',
    hashtag: '#',
    id: 1,
  },
  {
    name: 'bankerWinCount',
    className: 'player-chips red',
    iconClass: 'player-chips-info',
    text: 'b',
    id: 2,
  },
  {
    name: 'playerWinCount',
    className: 'player-chips blue',
    iconClass: 'player-chips-info',
    text: 'p',
    id: 3,
  },
  {
    name: 'tieCount',
    className: 'player-chips green',
    iconClass: 'player-chips-info',
    text: 't',
    id: 4,
  },
  {
    name: 'bankerWinWithPairCount',
    iconClass: 'right-sheet-oval-inner red',
    className: 'right-sheet-oval red',
    id: 5,
  },
  {
    name: 'playerWinWithPairCount',
    iconClass: 'right-sheet-oval-inner blue',
    className: 'right-sheet-oval blue',
    id: 6,
  },
];

export const betShopStatisticViewTypes = {
  BIG_ROAD1: 'type-2',
  BIG_ROAD2: 'type-1',
  BIG_ROAD3: 'type-3',
};
